import { motion } from "framer-motion";
import { IMG } from "../../data/assets";
import { fadeUp } from "../../lib/motion";
import { useLanguage } from "../../lib/i18n";

export const Chef = () => {
  const { t } = useLanguage();
  return (
    <section id="about" data-testid="chef-section" className="tiled relative py-8 md:py-12 bg-[--bg]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="lg:col-span-7">
          <div className="rounded-2xl overflow-hidden border border-[--olive]">
            <img src={IMG.chef} alt="Santiago Ruiz, private chef and founder" className="photo-grade w-full h-full object-cover aspect-[4/5]" />
          </div>
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="lg:col-span-5 lg:col-start-8 bg-[--surface] border border-white/10 rounded-2xl p-8 md:p-12">
          <p className="font-mono uppercase tracking-[0.3em] text-[11px] text-[--gold] mb-6">{t("chef.eyebrow")}</p>
          <h2 className="font-display font-light tracking-tight text-4xl md:text-5xl text-[--text] leading-tight">Santiago <span className="italic text-[--gold]">Ruiz</span></h2>
          <p className="font-mono uppercase tracking-[0.2em] text-[11px] text-[--text-2] mt-2 mb-6">{t("chef.role")}</p>

          <div className="space-y-4 text-[--text-2] text-base leading-relaxed">
            <p>{t("chef.p1")}</p>
            <p>{t("chef.p2")}</p>
            <p>{t("chef.p3")}</p>
          </div>

          <div className="flex flex-wrap gap-x-12 gap-y-4 mt-8 pt-8 border-t border-white/10">
            <div>
              <p className="font-mono uppercase tracking-[0.2em] text-[10px] text-[--gold] mb-1">{t("chef.specialities")}</p>
              <p className="text-[--text] text-sm">{t("chef.specval")}</p>
            </div>
            <div>
              <p className="font-mono uppercase tracking-[0.2em] text-[10px] text-[--gold] mb-1">{t("chef.based")}</p>
              <p className="text-[--text] text-sm">{t("chef.basedval")}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
